import { color as token } from '@figma/fpl-tokens/tokens.stylex';
import { color } from '@/colors';
import { LoadingCircle } from '@/UI/Animations/LoadingCircle';
import { FlexColCenHorVer } from '@/UI/styles';

/**
 * Spinner on a semi-transparent black overlay, shown while media in a node is
 * busy — either uploading from the user's machine or downloading/parsing an
 * existing asset (e.g. a 3D model on page refresh). Pass `label` to expose an
 * accessible description of what is loading, and `clickThrough` to let pointer
 * events reach the controls behind the overlay (e.g. the file carousel).
 */
export const MediaLoadingOverlay = ({ label, clickThrough }: { label?: string; clickThrough?: boolean }) => {
  return (
    <FlexColCenHorVer
      aria-busy={label ? true : undefined}
      aria-label={label}
      sx={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        backgroundColor: color.Black64_T,
        pointerEvents: clickThrough ? 'none' : undefined,
        gap: 1,
      }}
    >
      <LoadingCircle size={24} color={token.text} />
    </FlexColCenHorVer>
  );
};
